import { render, staticRenderFns } from "./localeChange.vue?vue&type=template&id=06e3854b"
import script from "./localeChange.vue?vue&type=script&lang=js"
export * from "./localeChange.vue?vue&type=script&lang=js"
import style0 from "./localeChange.vue?vue&type=style&index=0&id=06e3854b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports